import React, { useState } from 'react';
import resetTokesService from '../apis/resetTokesService';

const ResetTokesButton = () => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState({ success: null, message: '' });

  const handleReset = async () => {
    setIsLoading(true);
    const response = await resetTokesService.resetAllTokes();
    
    setResult({
      success: response.success,
      message: response.success 
        ? response.data.message 
        : response.error
    });
    
    setIsLoading(false);
  };

  const closeModal = () => {
    setShowModal(false);
    // Clear result after a short delay so the modal closes cleanly
    setTimeout(() => setResult({ success: null, message: '' }), 300);
  };

  return (
    <div className="mt-8">
      <div className="flex justify-center">
        <button
          className="px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white font-medium rounded-md transition-colors duration-300"
          onClick={() => setShowModal(true)}
        >
          Reset All Tokes
        </button>
      </div>

      {/* Modal Backdrop */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            {/* Modal Header */}
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-lg font-semibold">Confirm Reset</h3>
              <button 
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {/* Modal Body */}
            <div className="p-4">
              {result.message ? (
                <div className={`p-3 rounded-md mb-4 ${
                  result.success ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                }`}>
                  {result.message}
                </div>
              ) : (
                <p className="text-gray-700">
                  Are you sure you want to reset all tokes? This will clear all toke records and cannot be undone.
                </p>
              )}
            </div>
            
            {/* Modal Footer */}
            <div className="flex justify-end p-4 border-t gap-2">
              {!result.message ? (
                <>
                  <button
                    onClick={closeModal}
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleReset}
                    disabled={isLoading}
                    className={`px-4 py-2 text-white rounded-md transition-colors ${
                      isLoading ? 'bg-red-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'
                    }`}
                  >
                    {isLoading ? (
                      <span className="flex items-center">
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Processing...
                      </span>
                    ) : 'Confirm Reset'}
                  </button>
                </>
              ) : (
                <button
                  onClick={closeModal}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
                >
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetTokesButton;